<script>
import {mapActions} from "vuex";
import AfterDisposedItemModal from "@/driver/pages/masters/recycle_disposed_items/dialogs/AfterDisposedItemModal.vue";

export default {
  name: "DisposedItemModal",
  components: {AfterDisposedItemModal},
  props: {},
  data() {
    return {
      openModal: false,
      openRegisterModal: false,
      conditions: {
        code: null,
        without_invisible: true,
        after_type: 'after_industrial',
      },
      page: 1,
      perPage: 50,
      totalVisible: 7,
      pagination: {
        current_page: 1,
        total_count: 0,
      },
      tableHeaders: [
        { value: 'code', text: 'コード', width: '12%' },
        { value: 'after_type_name', text: '種別', width: '9%' },
        { value: 'major_name', text: '処理後物の大分類', width: '22%' },
        { value: 'subclass_name', text: '処理後物の種類', width: '31%' },
        { value: 'sort_priority', text: '表示順', align: 'right', width: '10%' },
        { value: 'updated_at', text: 'データ更新日時', width: '15%' },
      ],
      items: [],
      selectedItem: null,
      selectedRow: null,
    }
  },
  computed: {},
  watch: {
    openModal (val) {
      Object.assign(this.$data.conditions, this.$options.data().conditions);
      this.items = [];
      this.selectedItem = null;
      if (this.selectedRow) {
        this.selectedRow.select(false);
        this.selectedRow = null;
      }
      if (val) {
        this.searchButtonClick();
      }
    }
  },
  created() {},
  methods: {
    ...mapActions('DriverMasterRecycleDisposedItem', {
      fetchRecycleDisposedItems: 'index',
    }),
    searchButtonClick () {
      this.page = 1;
      this.search();
    },

    addButtonClick () {
      this.openRegisterModal = true;
    },

    selectButtonClick () {
      this.$emit("selected", this.selectedItem);
      this.closeModal();
    },

    /**
     * 排出事業者　行選択イベント
     * @param item
     * @param row
     */
    rowClickEvent(item, row) {
      this.selectedItem = item
      this.selectedRow = row
      row.select(true)
    },

    /**
     * 排出事業者　行反映ダブルクリックイベント
     * @param $event { MouseEvent }
     * @param row { Object } 行
     */
    rowDoubleClickEvent($event, row) {
      this.$emit("selected", row.item);
      this.closeModal();
    },

    /**
     * トグルボタン クリックイベント
     */
    menuChangeEvent () {
      this.searchButtonClick()
    },

    codeClearCallback () {
      this.conditions.code = null;
      this.searchButtonClick();
    },

    pageChangeCallback () {
      this.search();
    },

    closeModal() {
      this.openModal = false
    },

    /**
     * 追加・詳細・編集モーダル 閉じるコールバック
     */
    closeModalCallback () {
      this.openRegisterModal = false;
    },
    /**
     * 追加・編集モーダル 登録完了コールバック
     */
    registerCallback () {
      this.page = 1;
      this.search();
      this.closeModalCallback();
      this.$emit("reload")
    },

    search() {
      const params = {
        ...this.conditions,
        page: this.page,
        limit: this.perPage,
        useState: false,
      }
      this.fetchRecycleDisposedItems(params).then((content) => {
        this.items = content.recycle_disposed_items;
        this.pagination = content.pagination;
        this.scrollToTop();
      })
    },
    scrollToTop() {
      const elements = document.getElementsByClassName('v-dialog--active')
      if (!elements || !elements.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      const cards = elements[0].getElementsByClassName('card-layer')
      if (!cards || !cards.length) {
        // 要素が取得できなかった場合は終了
        return;
      }
      cards[0].scrollTop = 0;
    },
  },
}
</script>

<template>
  <div>
    <v-dialog
      v-model="openModal"
      persistent
      scrollable
      width="1200"
      @keydown.esc="closeModal"
      @close="closeModal"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          選択
        </v-btn>
      </template>
      <v-card flat>
        <v-toolbar
          flat
        >
          <v-toolbar-title>
            処理後物
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-title class="pa-2 my-1">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header class="panel-header-color panel-selectable">
                <strong>
                  <v-icon class="panel-header-color">
                    mdi-magnify
                  </v-icon>
                  &nbsp;条件を指定して検索
                </strong>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="5">
                        <v-text-field
                          v-model="conditions.code"
                          class="search-font"
                          clearable
                          dense
                          hide-details
                          label="コード"
                          outlined
                          persistent-placeholder
                          placeholder="部分一致で検索"
                          rounded
                          @blur="searchButtonClick"
                          @click:clear="codeClearCallback"
                        />
                      </v-col>
                      <v-col v-if="false" cols="12" md="4">
                        <v-checkbox
                          v-model="conditions.without_invisible"
                          dense
                          label="非表示を表示しない"
                          persistent-hint
                          class="mt-2"
                          @change="searchButtonClick"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" @click="searchButtonClick">
                      <v-icon>mdi-magnify</v-icon>&nbsp;検索
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-title>
        <v-card-title class="pa-2">
          <v-btn-toggle
            v-model="conditions.after_type"
            class="toggleButton"
            color="info accent-3"
            tile
            light
            mandatory
            rounded
            @change="menuChangeEvent"
          >
            <v-btn
              value="after_industrial"
              width="140"
            >
              廃棄物
            </v-btn>
            <v-btn
              value="after_recycling"
              width="140"
            >
              再資源
            </v-btn>
          </v-btn-toggle>
          <v-spacer />
          <div>
            <v-btn
              color="primary"
              @click="addButtonClick"
            >
              新規追加&nbsp;<v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="pa-1 card-layer" style="height: 45vh">
          <v-sheet class="mt-5 mb-5" rounded>
            <v-data-table
              :headers="tableHeaders"
              :items="items"
              :items-per-page="-1"
              disable-pagination
              disable-sort
              hide-default-footer
              single-select
              @click:row="rowClickEvent"
              @dblclick:row="rowDoubleClickEvent"
            >
              <!-- コード -->
              <template v-slot:[`item.code`]="{ item }">
                {{ item.code }}
              </template>
              <!-- /コード -->

              <!-- 種別 -->
              <template v-slot:[`item.after_type_name`]="{ item }">
                <div :title="item.after_type_name">{{ item.after_type_name }}</div>
              </template>
              <!-- /種別 -->

              <!-- 処理後物の大分類 -->
              <template v-slot:[`item.major_name`]="{ item }">
                <div class="line-clamp one-clamp" :title="item.major_name">{{ item.major_name }}</div>
              </template>
              <!-- /処理後物の大分類 -->

              <!-- 処理後物の種類 -->
              <template v-slot:[`item.subclass_name`]="{ item }">
                <div class="line-clamp one-clamp" :title="item.subclass_name">{{ item.subclass_name }}</div>
              </template>
              <!-- /処理後物の種類 -->

              <!-- データ更新日時 -->
              <template v-slot:[`item.updated_at`]="{ item }">
                {{ item.updated_at | unix_datetime_format }}
              </template>
              <!-- /データ更新日時 -->

            </v-data-table>
          </v-sheet>

          <v-row dense>
            <v-col>
              <v-pagination
                v-model="page"
                :length="pagination.total_pages"
                :total-visible="totalVisible"
                circle
                next-icon="mdi-menu-right"
                prev-icon="mdi-menu-left"
                @input="pageChangeCallback"
              />
            </v-col>
          </v-row>

        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn @click="closeModal">閉じる</v-btn>
          <v-btn color="primary" @click="selectButtonClick">選択</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <after-disposed-item-modal
      :enable="openRegisterModal"
      :after_type="conditions.after_type"
      @close="closeModalCallback"
      @register="registerCallback"
    />
  </div>
</template>

<style scoped lang="scss">

</style>
